// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar_calendar__I65Qb","month":"calendar_month__3AMC2","day":"calendar_day__1CVFl"};